import $ from "jquery"
import { access, isDef, isString, isUndef, objLength } from "../../support/general";
import { sendCommand } from "../../support/LocalCommand";
import { cloneBlock, makeUniversalBlockKey, modelStore } from "./model";
import { executeBlockLevelUpdate } from "./changes";
import { showDialog } from "../../support/modal_dialog";

// var nextRangeSignalClassId = 1;

// var changes = [];
// var atChange = -1;

export function doChange(change){

    var script = access(modelStore.state,["model","Script",change.scriptId]);
    if (script){
        var subscript = script.subscripts[change.subscriptId];
        if (subscript){
            subscript.changes =  subscript.changes??[];
            subscript.atChange = subscript.atChange??0;

            if (subscript.atChange<subscript.changes.length-1){
                subscript.changes.splice(subscript.atChange+1)
            }
            while (subscript.changes.length>350){
                subscript.changes.shift();
                subscript.atChange -= 1;
            }
            subscript.changes.push(change);
            change.performDo();
            subscript.atChange = subscript.changes.length-1;
        }
    }
}

export function undoChange(scriptId,subscriptId){
    var script = access(modelStore.state,["model","Script",scriptId]);
    if (script){
        var subscript = script.subscripts[subscriptId];
        if (subscript){
            subscript.changes =  subscript.changes?subscript.changes:[];
            subscript.atChange = subscript.atChange?subscript.atChange:0;
            if (subscript.atChange>=0){
                subscript.changes[subscript.atChange].performUndo(modelStore.state);
                subscript.atChange--;
            }
        }
    }

}

export function redoChange(scriptId,subscriptId){
        var script = access(modelStore.state,["model","Script",scriptId]);
    if (script){
        var subscript = script.subscripts[subscriptId];
        if (subscript){
            subscript.changes =  subscript.changes?subscript.changes:[];
            subscript.atChange = subscript.atChange?subscript.atChange:0;
            if (subscript.atChange<subscript.changes.length-1){
                subscript.changes[subscript.atChange+1].performDo(modelStore.state);
                subscript.atChange++;
            }
        }
    }
}

export function makeDirty() {

    var deletions = {};
    var creations = {};
    var edits = {};
    var changedScript = null;
    var changedScriptBits = {};
    
    var subscriptDeletions = {};
    var reorderedSubscriptIds = {};

    return {

        add :function( scriptId , dirty ) {

            if (dirty.script){
                throw "Can't change a script like this"
            }
            
            // console.log ("dirty.add",dirty);

            $.each(dirty.deletions,(d,deletionId)=>{
                var uid = makeUniversalBlockKey(scriptId,deletionId);
                delete deletions[uid];
                delete creations[uid];
                delete edits[uid];
                deletions[uid]={scriptId:scriptId,blockId:deletionId};
            });

            $.each(dirty.creations,(d,block)=>{
                var uid = makeUniversalBlockKey(scriptId,block.id);
                if (deletions[uid]){
                    delete deletions[uid];
                    dirty.edits =  dirty.edits? dirty.edits:[];
                    dirty.edits.push(blockToEdit(block))
                } else {
                    delete creations[uid];
                    delete edits[uid];
                    creations[uid]={scriptId:scriptId,block:blockToBlockData(block)};
                }
            });

            $.each(dirty.edits,(d,edit)=>{
                var uid = makeUniversalBlockKey(scriptId,edit.id);
                delete deletions[uid];
                if (creations[uid]) {
                    applyBlockEdits (edit.id,creations[uid].block,edit);
                    delete edits[uid];
                } else if (edits[uid]){
                    applyBlockEdits (edit.id,edits[uid],edit);
                } else {
                    edits[uid] = edit;
                }
            });

            $.each(dirty.subscriptDeletions,(sd,subscriptDeletionId)=>{
                subscriptDeletions[subscriptDeletionId]={scriptId:scriptId,subscriptId:subscriptDeletionId};
            });

            $.each(dirty.reorderedSubscriptIds,(sd,reorderedSubscriptId)=>{
                reorderedSubscriptIds[reorderedSubscriptId]={scriptId:scriptId,subscriptId:reorderedSubscriptId};
            });
            

            if (dirty.scriptChange){

                // changedScript = changedScript?changedScript:{};

                // if(dirty.scriptChange.bits.s){
                //     changedScript = $.extend(true,{},dirty.scriptChange.script.subscripts);
                // }
                // if(dirty.scriptChange.bits.nbid){
                //     changedScript.nextBlockId = dirty.scriptChange.script.nextBlockId;
                // }
                // if(dirty.scriptChange.bits.nsid){
                //     changedScript.nextSubscriptId = dirty.scriptChange.script.nextSubscriptId;
                // }
                // if(dirty.scriptChange.bits.nfid){
                //     changedScript.nextCustomFieldId = dirty.scriptChange.script.nextCustomFieldId;
                // }

                changedScriptBits = $.extend(changedScriptBits,dirty.scriptChange.bits);
                var script = dirty.scriptChange.script;

                changedScript = {
                    id : script.id,
                    name : script.name,
                    nextSubscriptId : script.nextSubscriptId,
                    subscripts : subscriptsToSubscriptDatas(script.subscripts),
                    nextBlockId : script.nextBlockId,
                    nextCustomFieldId : script.nextCustomFieldId,
                };
            }
        },
 
        getUpdates : function(scriptId){
            if (
                Object.keys(deletions).length ||
                Object.keys(creations).length ||
                Object.keys(edits).length ||
                Object.keys(subscriptDeletions).length ||
                changedScript ||
                Object.keys(reorderedSubscriptIds).length
            ) {
                // console.log ("get dirty updates");

                if (Object.keys(reorderedSubscriptIds).length){
                    var reorders = []
                    $.each(reorderedSubscriptIds,(subscriptId,reorder)=>{
                        var model = modelStore.state.model;
                        var subscript = access(model,["Script",reorder.scriptId,"subscripts",subscriptId]);
                        if (subscript){
                            var ordered=[];
                            $.each(subscript.orderedIds,(i,blockId)=>{
                                ordered.push({
                                    blockId,
                                    ordering : model.Block[makeUniversalBlockKey(reorder.scriptId,blockId)].ordering
                                })
                            });
                            reorders.push({
                                scriptId : reorder.scriptId,
                                ordered
                            })
                        }
                    })
                }

                // var script = null;
                // if (changedScript){
                //     script = 
                //     var currentScript = modelStore.state.model.Script[scriptId];

                //     script = $.extend(true,{},{
                //         id : currentScript.id,
                //         name : currentScript.name,
                //         nextSubscriptId : currentScript.nextSubscriptId,
                //         subscripts : subscriptsToSubscriptDatas(currentScript.subscripts),
                //         nextBlockId : currentScript.nextBlockId,
                //         nextCustomFieldId : currentScript.nextCustomFieldId,
                //     })
                //     // script = $.extend(true,script,changedScript);
                // }
                
                var updates = {
                    deletions,
                    creations,
                    edits,
                    script : changedScript,
                    subscriptDeletions,
                    reorders,
                };

                // console.log ("updates",updates);
                return updates;
            }
        }

    }

    function applyBlockEdits(blockId,target,source){
        target.blockId = blockId;
        if (source.bits['t']){
            target.text = source.text;
            if (target.bits){
                target.bits['t']=true;
            }
        }
        if (source.bits['m']){
            target.meta = source.meta;
            if (target.bits){
                target.bits['m']=true;
            }
        }
        if (source.bits['y']){
            target.type = source.type;
            if (target.bits){
                target.bits['y']=true;
            }
        }

    }

}

export function blockToEdit(block){
    var edit = blockToBlockData(block);
    edit.bits = {t:true,y:true,m:true,n:true};
    return edit;
}

export function blockToBlockData(block){

    return {
        id : block.id,
        text : block.text,
        type : block.type,
        meta : $.extend(true,{},block.meta),
        ordering : block.ordering,
        subscriptId : block.subscriptId,
        reference : isDef(block.reference)?block.reference:0,
    };
}

function subscriptsToSubscriptDatas(subscripts){
    var subscriptDatas = {};

    $.each(subscripts,(s,subscript)=>{
        subscriptDatas[subscript.id] =  {
            name : subscript.name,
            parentSubscriptId : subscript.parentSubscriptId,
            id : subscript.id,
            type : subscript.type,
            columns : subscript.columns ? subscript.columns.slice(0) : [] ,
            customFields : subscript.customFields ? ($.extend(true,{},subscript.customFields)) : {}
        }
    })

    return subscriptDatas;
}
export var currentDirty = makeDirty();
var dirtyReviewTimeout;

function reviewPendingUpdates(scriptId,subscriptId){
    // console.log ("reviewPendingUpdates");

    var now = new Date().getTime();
    if (!dirtyReviewTimeout){
        dirtyReviewTimeout = setTimeout(()=>{
            if (!updatesInProgress){

                cleanPendingUpdates(scriptId,subscriptId);
                
            } else {
                updateOverdue = true;
                overdueScriptId = scriptId;
                overdueSubscriptId = subscriptId;
            }
        },1000);
    }
}

var updateOverdue = false;
var updatesInProgress = false;
var overdueScriptId = 0;
var overdueSubscriptId = 0;

function clearUpdatesInProgress(){
    updatesInProgress = false;
    if (updateOverdue){
        updateOverdue = false;
        cleanPendingUpdates(overdueScriptId,overdueSubscriptId);
    }
}

function cleanPendingUpdates(scriptId) {
    // console.log("cleanPendingUpdates")

    if(updatesInProgress){
        throw ("Can't perform one update while another is in progress");
    }
    var updates = currentDirty.getUpdates(scriptId);

    clearTimeout ( dirtyReviewTimeout );
    dirtyReviewTimeout = null;
    if (updates){

        updatesInProgress = true;

        var script = access(modelStore.state,["model","Script",scriptId]);
        var duplicateModel = cloneModel(modelStore.state.model);

        if (updates.script){
            console.log ("Duplicate Script",duplicateModel.Script[1]);
            if (updates.script.nextBlockId != duplicateModel.Script[1].nextBlockId){
                var ii=0;
                console.log ("NextBlockIds don't match.");
            }
        }

        modelStore.dispatch(state=>{
            state.isSending = true;
        });

        sendCommand({
            action : {
                scriptId : scriptId,
                ownershipId : script.ownershipId,
                objectType : 'Script',
                verb : 'update',
                scriptId,
                updates : updates,
                onSucceeded : result =>{
                    checkModelConsistency(scriptId,duplicateModel,()=>{
                        modelStore.dispatch(state=>{
                            state.isSending = false;
                        });
                        clearUpdatesInProgress();
        
                    });
                },
            },
            onError : {
                "Invalid ownership" : ()=>{
                    showDialog ({
                        title : "Editing conflict.",
                        message : "Reload the page to retake control."
                    });
                }
            }
        });
    }

    currentDirty = makeDirty();

}

function checkModelConsistency(scriptId,duplicateModel,onFinished){

    var script = modelStore.state.model.Script[scriptId];
    var loadedSubscripts = [];
    $.each(script.subscripts,(subscriptId,subscript)=>{
        if (subscript.isLoaded){
            loadedSubscripts.push(subscriptId);
        }
    })

    sendCommand({
        action : {
            scriptId : scriptId,
            objectType : 'Script',
            verb : 'debugDump',
            loadedSubscripts,
            scriptId,
            onSucceeded : result =>{
                checkModelDumpForConsistency(scriptId,result,duplicateModel,loadedSubscripts);
                onFinished();
            }
        },
    });
}

function cloneModel(model){
    var Script = {}
    var Block = {}

    $.each(model.Script,(scriptId,script)=>{
        var subscripts = {};
        $.each(script.subscripts,(subscriptId,subscript)=>{
            subscripts[subscriptId] = {
                id : subscript.id,
                name : subscript.name,
                type : subscript.type,
                parentSubscriptId : subscript.parentSubscriptId,  
                customFields : $.extend({},subscript.customFields),           
            }
        });
        Script[scriptId] = $.extend(true,{},{
            name : script?script.name:"",
            id : script.id,
            ownershipId : script.ownershipId,
            nextBlockId : script.nextBlockId,
            nextSubscriptId : script.nextSubscriptId,
            nextCustomFieldId : script.nextCustomFieldId,
            subscripts : subscripts,
            // customFields : script.customFields,
            directoryColumns : script.directoryColumns,
            navigationColumns : script.navigationColumns,
        });
    })

    $.each(model.Block,(blockUrl,block)=>{
        Block[blockUrl] = $.extend(true,{},{
            id : block.id,
            scriptId  : block.scriptId ,
            type : block.type,
            text : block.text,
            meta : block.meta,
            subscriptId : block.subscriptId,
            reference : block.reference,
            ordering : block.ordering,
        });
    })

    return {
        Script,
        Block,
    }
}
function checkModelDumpForConsistency(scriptId,result,duplicateModel,loadedSubscripts){

    // console.log ("checkModelDumpForConsistency");

    var dScript = result.script;
    dScript.subscripts = JSON.parse(dScript.subscripts);
    dScript.navigationColumns = JSON.parse(dScript.navigationColumns);
    dScript.directoryColumns = JSON.parse(dScript.directoryColumns);
    // dScript.customFields = JSON.parse(dScript.customFields);
    var lScript = duplicateModel.Script[scriptId];

    var dBlocks = result.blocks;
    $.each(dBlocks,(blockUid,block)=>{
        block.meta = JSON.parse(block.meta);
    })

    // subscripts
    $.each(loadedSubscripts,(i,subscriptId)=>{
        checkSubscriptDump(duplicateModel,scriptId,lScript.subscripts[subscriptId],dScript.subscripts[subscriptId],dBlocks);
    });

    // $.each(lScript.subscripts,(s,lSubscript)=>{
    //     checkSubscriptDump(duplicateModel,scriptId,  lSubscript            , dScript.subscripts[s]    ,dBlocks);
    // })
    
    // $.each(dScript.subscripts,(s,dSubscript)=>{
    //     checkSubscriptDump(duplicateModel,scriptId,  lScript.subscripts[s] , dScript.subscripts[s]    ,dBlocks);
    // })

    // script meta

    // if (JSON.stringify(dScript.customFields) != JSON.stringify(lScript.customFields)){
    //     consistencyError("Script customFields do not match")
    // }

    if (lScript.nextBlockId != dScript.nextBlockId){
        consistencyError("Script nextBlockId do not match")
    }
    if (lScript.name != dScript.name){
        consistencyError("Script name do not match")
    }

    if (lScript.nextSubscriptId != dScript.nextSubscriptId){
        consistencyError("Script nextSubscriptId do not match")
    }

    if (lScript.nextCustomFieldId != dScript.nextCustomFieldId){
        consistencyError("Script nextCustomFieldId do not match")
    }

}

function checkSubscriptDump(duplicateModel,scriptId,lSubscript,dSubscript,dBlocks){

    // console.log ("checkSubscriptDump : ")

    if (!lSubscript || !dSubscript){
        consistencyError("A Subscript does not match");
    }

    if (lSubscript.parentSubscriptId != dSubscript.parentSubscriptId){
        consistencyError("A parentSubscriptId does not match");
    }

    if (!lSubscript.id || lSubscript.id != dSubscript.id){
        consistencyError("Subscript id does not match");
    }


    if (lSubscript.orderedIds && lSubscript.orderedIds.length){
        var blocks = [];
        $.each(dBlocks,(blockUid,block)=>{
            if (block.subscriptId==lSubscript.id) {
                blocks.push(block);
            }
        });
        blocks.sort((a,b)=>a.ordering-b.ordering);
        if (blocks.length != lSubscript.orderedIds.length){
            consistencyError("Subscript block count does not match : "+ lSubscript.id);
        }
        for (var i=0;i<blocks.length;i++){
            var dBlock = blocks[i];
            var lBlock = duplicateModel.Block[makeUniversalBlockKey(scriptId,lSubscript.orderedIds[i])];
            checkBlockDump(duplicateModel,scriptId,dBlock,lBlock,dBlocks);
        }
    }
}

function checkBlockDump(duplicateModel,scriptId,dBlock,lBlock,dBlocks){
    
    // console.log ("checkBlockDump : " + lBlock.id);

    if (!lBlock || !dBlock){
        consistencyError("Blocks do not exist.")
    }

    if (lBlock.id != dBlock.id){
        consistencyError("BlockIds do not match")
    }

    if (!lBlock || !dBlock){
        consistencyError("A Block does not exist");
    }

    if (lBlock.id != dBlock.id){
        consistencyError("Block id do not match")
    }

    if (lBlock.text != dBlock.text){
        consistencyError("Block text do not match")
    }
    if (lBlock.type != dBlock.type){
        consistencyError("Block id do not match")
    }
    if (lBlock.subscriptId != dBlock.subscriptId){
        consistencyError("Block id do not match")
    }
    if (lBlock.ordering != dBlock.ordering){
        consistencyError("Block ordering do not match")
    }
    if (lBlock.reference != dBlock.reference){
        consistencyError("Block reference do not match")
    }
    if (JSON.stringify(lBlock.meta) != JSON.stringify(dBlock.meta)){
        consistencyError("Block meta do not match")
    }
    return [lBlock,dBlock];

}
function consistencyError(error){
    throw ("consistencyError : "+ error);
}


export function dispatchUpdate(scriptId,subscriptId,update,rangeBefore){
    // performs a change, complete with invalidations but does not add it to the undo/redo queue

    return makeChange(scriptId,subscriptId,update,rangeBefore).performDo();
}

export function executeUpdate(state,scriptId,subscriptId,update,dirty){
    
    var result = update.executeDo(state,scriptId,subscriptId,dirty);
    result = result?result:{};
    state.dealWithSubscriptInvalidations(scriptId,subscriptId,result);

    return result;
}

export function makeChange(scriptId,subscriptId,update,rangeBefore){

    return {
        scriptId,
        subscriptId,

        update : update,
        reinstate : null,
        rangeBefore : rangeBefore,
        returnValue : null, // passes value back from do/undo
        performDo : function (){

            
            modelStore.dispatch((state)=>{

                var result = executeUpdate(state,scriptId,subscriptId,this.update,currentDirty);

                this.reinstate = result.undo?result.undo:{};
                this.reinstate.subscriptOrderInvalid = result.subscriptOrderInvalid;
                this.reinstate.navTreeInvalid = result.navTreeInvalid;
                this.returnValue = result.returnValue;
            });

            reviewPendingUpdates(scriptId,subscriptId);

            return this.returnValue;
        },

        performUndo : function (){

            modelStore.dispatch((state)=>{

                var result = executeBlockLevelUpdate(state,scriptId,subscriptId,this.reinstate,currentDirty);
                result.range = this.rangeBefore;
                state.dealWithSubscriptInvalidations(scriptId,subscriptId,result);

            });

            reviewPendingUpdates(scriptId,subscriptId);;
        },

    };


}

